var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBank = function SvgBank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.738 2.074a.5.5 0 0 1 .524 0l6.5 4A.5.5 0 0 1 14.5 7h-13a.5.5 0 0 1-.262-.926l6.5-4ZM3.267 6h9.466L8 3.087 3.267 6Z",
    fill: "#69B6AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 6a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0v-5a.5.5 0 0 1 .5-.5ZM6.5 6a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0v-5a.5.5 0 0 1 .5-.5ZM9.5 6a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0v-5a.5.5 0 0 1 .5-.5ZM12.5 6a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0v-5a.5.5 0 0 1 .5-.5Z",
    fill: "#69B6AA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 11.5A.5.5 0 0 1 2 11h12a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5ZM.5 13.5A.5.5 0 0 1 1 13h14a.5.5 0 0 1 0 1H1a.5.5 0 0 1-.5-.5Z",
    fill: "#69B6AA"
  })));
};
export default SvgBank;